import styled from 'styled-components';

export const InputSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 10px;
`;

export const Label = styled.label`
  position: relative;
  display: block;
  width: 100%;
  //letter-spacing: 1px;
  padding-top: 10px;
  text-align: left;
  margin-bottom: 5px;
  font-size: 16px;
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;

  border-radius: 6px;
  border: 1px solid #e6e6e6;
  width: 100%;
  height: 40px;
  padding: 6px 10px;
  box-sizing: border-box;
`;

export const Input = styled.input`
  margin-left: 5px;
  width: 100%;
  height: 100%;
  border: none;
  font-size: 14px;

  &&:focus {
    outline: none;
  }
  input:focus {
    outline: none;
    box-shadow: none;
    border: none;
    background-color: inherit; /* 保持背景色一致 */
    color: inherit; /* 保持文本颜色一致 */
  }

  /* 移除悬停样式 */
  input:hover {
    outline: none;
    box-shadow: none;
    border: none;
    background-color: inherit; /* 保持背景色一致 */
    color: inherit; /* 保持文本颜色一致 */
  }
`;

export const Error = styled.p`
  margin-top: 5px;
  color: #b60000;
  font-size: 12px;
  text-align: left;
  margin-bottom: 0;
`;
